import React from 'react';
import { LargeHeading } from '@/components/Views/Heading';
import { NormalText } from '@/components/Views/Text';
import LargeButton from '@/components/Views/Buttons';
import Image from '@/components/ReusableUI/Image';

export const BillboardArticle = ({ image }) => {
    return (<section id={'billboard-article'} className='creators-rock default-px default-py'>
            <div className='creators-rock--wrapper'>
                <div className='mx-auto default-max-w'>
                    <div className='mt-12 text-center'>
                        <img
                            src={'https://muzology-media.s3.amazonaws.com/images/billboard-png-34780_1.original.png'}
                            alt={'Billboard Logo'}
                        />
                    </div>

                    <div className='w-full mt-[0px]'>
                        <img
                            src={"https://muzology-media.s3.amazonaws.com/images/billboard-articles-deep-dive-how-to-crack-the-k.original.png"}
                            width={'100%'}
                            height={'auto'}
                            alt={'Billboard Article'}
                        />

                        {/*
                        <Image
                            image={image}
                            priority={true}
                            className='w-full bg-red-100 mt-6'
                            objectFit={'contain'}
                            style={{maxWidth: '100%', height: 'auto'}}
                        />
                        */}
                    </div>
                </div>
            </div>
            <style jsx>{`
                .creators-rock {
                    width: 100%;
                    background: #fff;

                    .creators-rock--wrapper {
                        .creators-rock--content {
                            display: flex;
                            align-items: center;

                            .creators-rock--content-child {
                                &:first-child {
                                    padding-right: 85px;
                                    flex: 1;
                                }

                                &:last-child {
                                    padding-left: 10px;
                                    max-width: 50%;
                                }

                                .creators-rock--title {
                                    font-weight: 800;
                                    font-size: 42px;
                                    line-height: 48px;
                                    color: #121651;
                                    margin: 0;
                                }

                                .creators-rock--description {
                                    font-weight: 500;
                                    font-size: 18px;
                                    line-height: 25px;
                                    color: #4f4f4f;
                                    margin: 25px 0 0;
                                }

                                .creators-rock--photos {
                                    display: flex;
                                    align-items: center;
                                    margin: 40px 0 0 0;

                                    &.hide-desktop {
                                        display: none;
                                        @media (max-width: 767px) {
                                            display: flex;
                                        }
                                    }

                                    &.hide-mobile {
                                        display: flex;
                                        @media (max-width: 767px) {
                                            display: none;
                                        }
                                    }

                                    .creators-rock--photo-wrapper {
                                        flex: 1;
                                        max-width: 90px;
                                        max-height: 110px;
                                        margin: 0 8px;

                                        img {
                                            width: 100%;
                                            height: auto;
                                        }

                                        &:first-child {
                                            margin-left: 0;
                                        }

                                        &:last-child {
                                            margin-right: 0;
                                        }
                                    }
                                }

                                .creators-rock--featured {
                                    max-width: 100%;
                                    height: auto;
                                }
                            }
                        }
                    }

                    @media (max-width: 992px) {
                        //padding: 48px 40px;
                    }

                    @media (max-width: 768px) {
                        //padding: 48px 40px 20px;
                        .creators-rock--wrapper {
                            .creators-rock--content {
                                flex-direction: column;

                                .creators-rock--content-child {
                                    &:first-child {
                                        padding: 0 0 15px;
                                    }

                                    &:last-child {
                                        padding: 15px 0 0;
                                        max-width: 100%;
                                    }

                                    .creators-rock--title {
                                        font-size: 36px;
                                        text-align: center;
                                    }

                                    .creators-rock--description {
                                        font-size: 16px;
                                    }

                                    .creators-rock--photos {
                                        justify-content: center;
                                    }
                                }
                            }
                        }
                    }

                    @media (max-width: 480px) {
                        //padding: 48px 20px;
                    }
                }
            `}</style>
        </section>);
};
